import { useMemo } from "react";
import apiInstance from "../../helpers/apiInstance";

function usePermissions() {
  const basePath = useMemo(() => {
    return `/permission`;
  }, []);

  return {
    getPermissions: () => apiInstance.get(basePath),
  };
}

export default usePermissions;
